// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FpJJV","label":"styles_label__r26WK","description":"styles_description__xBRqU","input":"styles_input__b_6YS","error":"styles_error__vbIPn"};